import { Error, Section } from '@tracklib/kit'

const ErrorPage = () => {
  return (
    <Section size="small">
      <Error message="Page not found" />
    </Section>
  )
}

export default ErrorPage
